import React from 'react';

const GalleryHandlers = ({ galleryImages, setGalleryImages, children }) => {
  const handleGalleryImagesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;
    
    const newPreviews = files.map(file => ({ 
        url: URL.createObjectURL(file), 
        isFromDatabase: false, 
        fileObject: file,
        original_url: '',
        resize_url: ''
    }));
    
    setGalleryImages(prev => {
        const combined = [...prev, ...newPreviews];
        return combined.map((img, index) => ({ ...img, sort: index + 2 }));
    });
  };

  const handleGalleryImageRemove = (imageToRemove) => {
    setGalleryImages(prevImages => {
      const updatedImages = prevImages.filter(img => img !== imageToRemove);
      return updatedImages.map((img, idx) => ({ ...img, sort: idx + 2 }));
    });
  };

  const handleUpdateSortOrder = (e) => {
    const newOrder = e.value;
    setGalleryImages(newOrder.map((img, index) => ({
      ...img,
      sort: index + 2
    })));
  };

  return children({
    handleImagesChange: handleGalleryImagesChange,
    handleImageRemove: handleGalleryImageRemove,
    handleUpdateSortOrder: handleUpdateSortOrder,
  });
};

export default GalleryHandlers;